module.exports = __webpack_public_path__ + "img/playerEval.899afa21.svg";